import { HttpService, HttpServiceResponse } from '../shared'
import { PasswordRulesServerData } from './userConfig.types'

export class UserOperProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return `${this.baseUrl}/user_oper_api.php`
  }

  public getPasswordRules(userID: number, hash?: string): Promise<HttpServiceResponse<PasswordRulesServerData>> {
    return this.http.post(`${this.url}?action=viewpassrules`, {
      SEC_UserID: userID,
      HashSum_UserID_: hash,
    })
  }

  public changePassword(
    userID: number,
    password: string,
    newPassword: string,
    hash?: string,
  ): Promise<HttpServiceResponse<unknown>> {
    const params: Record<string, number | string> = {
      UserID: userID,
      NewPass: newPassword,
      HashSum_UserID_: hash,
      OldPass: password || '',
    }

    // if (password) {
    //   params.OldPass = password
    // }

    return this.http.post(`${this.url}?action=changepass`, params)
  }
}
